//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 05/09/2024
// Version : 1
// Description : Tabla de proximas fechas de revision
//------Changes -------------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import { React, useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { UrlApi } from "../../services/apirest";


function RepuestosTareas({ tareasXtanque }) {
  // console.log("TAREAS X TANQUE DESDE REPUESTOS",tareasXtanque);
  const [datosRepuestos, setDatosRepuestos] = useState([]);

  const [tabla, setTabla] = useState(true);

  const obtenerRepuestosXtarea = () => {
    fetch(
      UrlApi +
        "/tanque_tarea/repuestoXTanqueyTarea/" +
        tareasXtanque.id_tanque +
        "/" +
        tareasXtanque.uuid_tarea
    )
      .then((data) => data.json())
      .then((data) => setDatosRepuestos(data));
  };

  // console.log("DATOS REPUESTOS DEL OBTENER", datosRepuestos);
  //ejecuta la funcion de obtener
  useEffect(() => {
    obtenerRepuestosXtarea();
  }, [tabla]);

  return (
    <div>
      <br></br>
      <br></br>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: 2,
          borderRadius: 1,
          overflow: "hidden",
          border: "1px solid #ccc",
          maxWidth: 500, // límite de ancho
        }}
      >
        <Table
          size="small"
          sx={{ borderCollapse: "collapse", fontSize: "0.85rem" }}
        >
          <TableHead sx={{ backgroundColor: "#2B76A6" }}>
            <TableRow sx={{ height: "25px" }}>
              <TableCell
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  padding: "4px 8px",
                  fontSize: "0.85rem",
                }}
              >
                Artículo
              </TableCell>
              <TableCell
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  padding: "4px 8px",
                  fontSize: "0.85rem",
                }}
              >
                Almacén
              </TableCell>
              <TableCell
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  padding: "4px 8px",
                  fontSize: "0.85rem",
                }}
              >
                Cantidad
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {datosRepuestos.map((repuesto, index) => (
              <TableRow
                key={repuesto.id_repuesto}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#f4f4f4" : "#fff",
                  height: "26px",
                  "&:last-child td": { borderBottom: 0 },
                }}
              >
                <TableCell sx={{ padding: "4px 8px", fontSize: "0.85rem" }}>
                  {repuesto.articulo_nombre}
                </TableCell>
                <TableCell sx={{ padding: "4px 8px", fontSize: "0.85rem" }}>
                  {repuesto.almacen_nombre}
                </TableCell>
                <TableCell sx={{ padding: "4px 8px", fontSize: "0.85rem" }}>
                  {repuesto.cantidad}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default RepuestosTareas;
